// extracted by mini-css-extract-plugin
export default {"inlineFormField":"thresholdPreferences_inlineFormField__3YOH-"};